"use strict";

require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.date.to-string");
require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
var decimal_js_1 = require("decimal.js");
var Notifications_1 = require("Core/Notifications");
var Step1Selectors_1 = require("Components/Cart/Step1/Step1Selectors");
var CartSelector_1 = require("Components/Cart/CartSelector");
var Currencies_1 = require("Core/Currencies");
var CartCommon = function () {
  function CartCommon() {}
  CartCommon.cartChangeHandler = function (res) {
    if (res.result) {
      if (res.value) {
        if (res.value.count > 0) {
          $(CartSelector_1.CartSelector.HEADER.QUANTITY_COUNTER).show().html(res.value.count.toString());
        } else {
          $(CartSelector_1.CartSelector.HEADER.QUANTITY_COUNTER).hide().html('0');
          $(Step1Selectors_1.Step1Selectors.FORM).hide(250);
        }
        $(CartSelector_1.CartSelector.HEADER.VALUE).html(res.value.total.toString());
      }
      if (res.type != 'error') {
        var notiText = CartCommon.makeMsgText(res.msg, res.value.amount, res.value.unit);
        Notifications_1.Notifications.add("" + notiText, res.type);
      } else {
        Notifications_1.Notifications.add("" + res.msg, res.type);
      }
    }
  };
  CartCommon.InputFocusoutHandler = function (element) {
    var _a = CartCommon.extractCommonData(element),
      $this = _a.$this,
      productId = _a.productId;
    var _b = CartCommon.extractInputCommonData($this),
      quantity = _b.quantity,
      maxQuantity = _b.maxQuantity,
      minQuantity = _b.minQuantity,
      step = _b.step;
    quantity = CartCommon.max4signs(quantity, maxQuantity);
    var digits = CartCommon.checkNumberIfFloat(quantity) ? 2 : 0;
    $this.val(quantity.toFixed(digits));
  };
  CartCommon.makeMsgText = function (msg, qty, unit) {
    if (typeof qty == 'number' && qty > 0) {
      return msg + ": " + qty + " " + unit;
    }
    return "" + msg;
  };
  CartCommon.extractCommonData = function (htmlElement) {
    var $this = $(htmlElement);
    var productId = $this.data('product-id');
    return {
      $this: $this,
      productId: productId
    };
  };
  CartCommon.extractInputCommonData = function (htmlInputElement) {
    var quantity = CartCommon.getDecimalFromHtmlElementValueOrDefault(htmlInputElement.val());
    var step = new decimal_js_1.Decimal(htmlInputElement.data('input-step') || 1);
    var maxQuantity = CartCommon.getDecimalFromHtmlElementValueOrDefault(htmlInputElement.attr('max'));
    var minQuantity = CartCommon.getDecimalFromHtmlElementValueOrDefault(htmlInputElement.attr('min'));
    return {
      quantity: quantity,
      maxQuantity: maxQuantity,
      minQuantity: minQuantity,
      step: step
    };
  };
  CartCommon.extractRowCommonData = function (jqueryHtmlInputElement) {
    var row = jqueryHtmlInputElement.closest(Step1Selectors_1.Step1Selectors.PRODUCT_AND_OFFER_CART.CONTAINER);
    var price = row.data('product-price');
    var total = row.find(Step1Selectors_1.Step1Selectors.PRODUCT_AND_OFFER_CART.TOTAL);
    var weight = parseFloat(row.find($(Step1Selectors_1.Step1Selectors.PRODUCT.UNIT_WEIGHT)).attr('data-unit-row-weight'));
    var totalElementWeight = row.find(Step1Selectors_1.Step1Selectors.PRODUCT.WEIGHT);
    var unitIsFloat = row.data('unit-is-float');
    return {
      row: row,
      price: price,
      total: total,
      weight: weight,
      totalElementWeight: totalElementWeight,
      unitIsFloat: unitIsFloat
    };
  };
  CartCommon.getDecimalFromHtmlElementValueOrDefault = function (val) {
    var quantity;
    try {
      quantity = new decimal_js_1.Decimal(val);
    } catch (e) {
      quantity = new decimal_js_1.Decimal(1);
    }
    return quantity;
  };
  CartCommon.ValidateProductQuantity = function (quantityDecimal, stepDecimal, maxDecimal) {
    var isFloat = CartCommon.checkNumberIfFloat(stepDecimal.toNumber());
    var validatedValue;
    if (isFloat) {
      validatedValue = Math.round(quantityDecimal.toNumber() / stepDecimal.toNumber()) * stepDecimal.toNumber();
    } else {
      validatedValue = Math.ceil(quantityDecimal.toNumber() / stepDecimal.toNumber()) * stepDecimal.toNumber();
    }
    quantityDecimal = new decimal_js_1.Decimal(validatedValue);
    if (quantityDecimal.isZero()) {
      quantityDecimal = stepDecimal;
    }
    var unitIsFloat = 0;
    if (isFloat) {
      unitIsFloat = 2;
    }
    return CartCommon.max4signs(quantityDecimal.toFixed(unitIsFloat), maxDecimal.toNumber());
  };
  CartCommon.max4signs = function (value, max_value) {
    max_value > 9999 ? max_value = 9999 : '';
    if (value >= max_value) {
      value = max_value;
    }
    return value;
  };
  CartCommon.checkNumberIfFloat = function (value) {
    return Number(value) === value && value % 1 !== 0;
  };
  CartCommon.calcCurrentElementWeight = function (qty, weight) {
    var totalWeight = qty * weight;
    var returnTotalWeight = totalWeight.toFixed(3).replace(".", ",");
    return returnTotalWeight;
  };
  CartCommon.showValuesAfterResponse = function (total_area, price, quantity) {
    $(total_area).text(Currencies_1.formatCurrency(price * quantity));
    $(total_area).attr('data-total-price', price * quantity);
  };
  CartCommon.setValueOnInput = function (input, quantity) {
    $(input).val(quantity);
  };
  CartCommon.prepareWeightValues = function (quantity, weight) {
    var qty = quantity.toNumber();
    var totalWeight = CartCommon.calcCurrentElementWeight(qty, weight);
    return totalWeight;
  };
  CartCommon.showWeightValues = function (weight_area, weight) {
    $(weight_area).html(weight);
  };
  CartCommon.isProductDigital = function (htmlElement) {
    var $this = $(htmlElement);
    return $this.data('product-is-digital') == true;
  };
  return CartCommon;
}();
exports.CartCommon = CartCommon;